// extracted by mini-css-extract-plugin
export default {"root":"iho-cho-register_root__C9hYd","title":"iho-cho-register_title__mgiSs","divider":"iho-cho-register_divider__cRiOi"};